import React from "react";

import styles from "./index.module.less";

const Introduction = () => {
  return (
    <div className={styles.careersContent}>
      <div className={styles.contentTitle}>Company introduction and corporate culture</div>
      <div className={styles.contentXtIntroduce}>Spikex Exchange was established in 2018 and registered in Seychelles. Its operating headquarters is located in Dubai. It has operation centers in
        Singapore, Seoul and other countries and regions, and its business covers the world.</div>
      <div className={styles.contentXtIntroduce}>Spikex is a comprehensive trading platform that supports 100+ high-quality currencies and 300 trading pairs. It has a rich variety of transactions such
        as currency transactions, leveraged transactions, OTC transactions, contract transactions, and credit card purchases. Provide users with the safest,
        most efficient and professional digital asset investment services.</div>
      <div className={styles.contentXtIntroduce}>Spikex is committed to diversity in its workforce and is proud to be an Equal Opportunity Employer. All qualified applicants will receive consideration
        for employment without regard to race, color, religion, creed, gender, national origin, age, disability, veteran status, sex, gender expression or
        identity, sexual orientation or any other basis protected by applicable law.</div>
    </div>
  );
};

export default Introduction;
